export default __webpack_public_path__ + "static/media/fig8.edac026c.jpg";